import { useQuery } from "@tanstack/react-query";
import { UserService } from "@/services/userService";
import { useTenant } from "./useTenant";

// Query keys for users
export const userKeys = {
  all: (tid: string) => ["users", tid] as const,
  allIncludingAdmins: (tid: string) => ["users", "all", tid] as const,
  byId: (id: string) => ["users", id] as const,
};

// Get all users (excluding admins)
export function useUsers() {
  const { tenantId } = useTenant();
  return useQuery({
    queryKey: userKeys.all(tenantId || ""),
    queryFn: () => UserService.getAllUsers(tenantId!),
    enabled: !!tenantId,
  });
}

// Get all users including admins
export function useAllUsers() {
  const { tenantId } = useTenant();
  return useQuery({
    queryKey: userKeys.allIncludingAdmins(tenantId || ""),
    queryFn: async () => {
      try {
        const result = await UserService.getAllUsersIncludingAdmins(tenantId!);
        return result;
      } catch (error) {
        console.error("useAllUsers: Query failed", error);
        throw error;
      }
    },
    enabled: !!tenantId,
    retry: 1,
    retryDelay: 1000,
  });
}

// Get user by ID
export function useUser(id: string) {
  const { tenantId } = useTenant();
  return useQuery({
    queryKey: userKeys.byId(id),
    queryFn: () => UserService.getUserById(id, tenantId || undefined),
    enabled: !!id,
  });
}
